export const systemSettingKeys = {
  all: ['system-settings'],
  list: (params: any) => ['system-settings', 'list', params],
  detail: (id: any) => ['system-settings', 'detail', id],
};
